import type { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';
import { isCustomDonationFundItemNoGoal, isGroupGiftPurchasedAsPhysical, isPricedProduct } from '@apps/registry/common/selectors/ProductListSelector';

export const isProductStillNeeded = (product: CookedProduct) => {
  return !((product.stillNeeded <= 0 && !isCustomDonationFundItemNoGoal(product)) || isGroupGiftPurchasedAsPhysical(product));
};

// registry_service returns a bare placeholder (no title, no price, no photos) when the item's product no longer exists.
export const isEmptyPlaceholderProduct = (product: CookedProduct) => {
  return !product.title?.trim() && !isPricedProduct(product) && !product.donationFund;
};
